import React, { FC } from "react";

import { bem } from "@react-md/utils";
import { Breadcrumb } from "antd";
import { BreadcrumbItemProps as AntdBreadcrumbItemProps } from "antd/es/breadcrumb";

const block = bem("mmc-breadcrumb-item");

export interface BreadcrumbItemProps extends AntdBreadcrumbItemProps {}

const BreadcrumbItem: FC<BreadcrumbItemProps> = (props) => {
  return <Breadcrumb.Item className={block()} {...props} />;
};

export default BreadcrumbItem;
